import { clearPersistedPinLock } from "./pin-utils";

export const medecine360SessionTokenKeyName = "medecine360SessionToken";
export const medecine360SessionQueryParamKeyName = "sessionToken";

export const storeQueryParams = () => {
  const urlSearchParam = new URLSearchParams(document.location.search);
  // MED-1644: a session token in the URL is a fresh login, so a lock flag
  // persisted by an earlier session must not lock it. Runs before the
  // PinLockProvider mounts (SessionProvider shows a loader until validated).
  if (urlSearchParam.get(medecine360SessionQueryParamKeyName)) {
    clearPersistedPinLock();
  }
  storeMedecine360SessionToken(urlSearchParam);
  removeSessionTokenFromURL(urlSearchParam);
};

/** Only the session token is consumed; other parameters (list filters, tabs) stay so deep links survive a reload. */
function removeSessionTokenFromURL(urlSearchParam: URLSearchParams) {
  if (urlSearchParam.has(medecine360SessionQueryParamKeyName)) {
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.delete(medecine360SessionQueryParamKeyName);
    const path = urlObj.toString();
    // Avoid page reload using pushState
    window.history.pushState({ path }, "", path);
  }
}
export const storeMedecine360SessionToken = (
  urlSearchParam: URLSearchParams
) => {
  const medecine360SessionToken = urlSearchParam.get(
    medecine360SessionQueryParamKeyName
  );
  if (medecine360SessionToken) {
    window.sessionStorage.setItem(
      medecine360SessionTokenKeyName,
      medecine360SessionToken
    );
  }
};
export const getMedecine360SessionTokenFromStorage = () => {
  return (
    window.sessionStorage.getItem(medecine360SessionTokenKeyName) ??
    new URLSearchParams(document.location.search).get(
      medecine360SessionQueryParamKeyName
    )
  );
};
export function removeMedecine360SessionTokenFromStorage() {
  if (window.sessionStorage.getItem(medecine360SessionTokenKeyName)) {
    window.sessionStorage.removeItem(medecine360SessionTokenKeyName);
  }
}

export const isTimeExpires = (expiresAt: Date) => {
  const expirationDate = new Date(expiresAt);

  const now = new Date();
  const timeDifference = expirationDate.getTime() - now.getTime();

  const countDown = Math.floor(timeDifference / 1000);
  return countDown < 0;
};
